export default __webpack_public_path__ + "static/media/879.8873f97d.png";